import { render } from "./ListingVatAccountCode.vue?vue&type=template&id=10cd1930"
import script from "./ListingVatAccountCode.vue?vue&type=script&lang=js"
export * from "./ListingVatAccountCode.vue?vue&type=script&lang=js"

import "./ListingVatAccountCode.vue?vue&type=style&index=0&id=10cd1930&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__